// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__toastContainer--Sr5Yq {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  position: fixed;
  z-index: 1400;
  pointer-events: none;
}
.style__toastWrapper--DA4Xm {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  pointer-events: none;
}
.style__toast--pvexy {
  background-color: #fff;
  border-radius: 0.5rem;
  color: #0c0d0d;
  padding: 1rem;
  align-items: center;
  display: flex;
  gap: 1rem;
  max-width: 358px;
  justify-content: center;
  pointer-events: auto;
  box-shadow: 0 0.75rem 1rem -0.25rem rgba(12, 13, 13, 0.1), 0 0.25rem 6px -0.125rem rgba(12, 13, 13, 0.05);
}
.style__toast--pvexy > span {
  cursor: pointer;
}
.style__toast--pvexy button {
  color: #0c0d0d;
  border-radius: 0;
}
.style__toast--pvexy hr {
  border-left: 1px solid #e3e8e5;
  height: 1.5rem;
}
.style__toastType--BiLlI {
  justify-content: left;
}
.style__toastTypeError--Dh3vL span {
  color: #d72a1d;
}
.style__toastTypeSuccess--TO1S0 span {
  color: #00a751;
}
.style__toastDismissible--zNeh_ {
  justify-content: space-between;
  gap: 1rem;
}
.style__toastAction--syQF_ {
  justify-content: space-between;
  gap: 1rem;
}
.style__toastActionButton--Iq02Y {
  display: flex;
}
.style__toastTop--vuyF2 {
  animation: 300ms ease-out forwards style__slide-down--rmAbl;
}
.style__toastBottom--Ap2J3 {
  top: 3rem;
  animation: 300ms ease-out forwards style__slide-up--d65DB;
}
.style__toastLeft--t5WlM {
  animation: 300ms ease-out forwards style__slide-left--X6PgO;
}
.style__toastRight--PVGfj {
  animation: 300ms ease-out forwards style__slide-right--knifu;
}
.style__toastRightEnd--Ukgdk {
  animation: 300ms ease-out forwards style__slide-right-end--HQeti;
}
.style__toastLeftEnd--fraOF {
  animation: 300ms ease-out forwards style__slide-left-end--PKEmk;
}
.style__toastLeftCenter--ma5bf {
  animation: 300ms ease-out forwards style__slide-left-center--ar_qE;
}
.style__toastRightCenter--Ap9sh {
  animation: 300ms ease-out forwards style__slide-right-center--Kuf2p;
}
.style__toastTopCenter--N9Oi5 {
  animation: 300ms ease-out forwards style__slide-top-center--vOGcC;
}
.style__toastBottomCenter--v22if {
  animation: 300ms ease-out forwards style__slide-bottom-center--Telj_;
}
.style__iconContainer--Nh_gQ {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2rem;
  height: 2rem;
}
.style__errorIcon--jcUgu {
  background-color: #ffd2cc;
  border-radius: 2rem;
}
.style__successIcon--uk_ST {
  background-color: #eaffe9;
  border-radius: 2rem;
}
@keyframes style__slide-up--d65DB {
  from {
    opacity: 0;
    right: calc(50vw - 358px / 2);
    transform: translateY(calc(100vh));
  }
  to {
    opacity: 1;
    transform: translateY(81vh);
    right: calc(50vw - 358px / 2);
  }
}
@keyframes style__slide-down--rmAbl {
  from {
    opacity: 0;
    transform: translateY(-3rem);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes style__slide-left--X6PgO {
  from {
    opacity: 0;
    left: 100vw;
  }
  to {
    opacity: 1;
    left: calc(100vw - 25rem);
  }
}
@keyframes style__slide-right--knifu {
  from {
    opacity: 0;
    left: -100%;
  }
  to {
    opacity: 1;
    left: 1rem;
  }
}
@keyframes style__slide-right-end--HQeti {
  from {
    opacity: 0;
    right: 100%;
  }
  to {
    opacity: 1;
    right: 1rem;
  }
}
@keyframes style__slide-left-end--PKEmk {
  from {
    opacity: 0;
    left: 100vw;
  }
  to {
    opacity: 1;
    left: 1rem;
  }
}
@keyframes style__slide-left-center--ar_qE {
  from {
    top: 1rem;
    bottom: 1rem;
    opacity: 0;
    left: 100vw;
  }
  to {
    top: 1rem;
    bottom: 1rem;
    opacity: 1;
    left: calc(50vw - 358px / 2);
  }
}
@keyframes style__slide-right-center--Kuf2p {
  from {
    opacity: 0;
    right: 100vw;
  }
  to {
    opacity: 1;
    right: calc(50vw - 358px / 2);
  }
}
@keyframes style__slide-top-center--vOGcC {
  from {
    opacity: 0;
    transform: translateY(-3rem);
    right: calc(50vw - 358px / 2);
  }
  to {
    opacity: 1;
    transform: translateY(0);
    right: calc(50vw - 358px / 2);
  }
}
@keyframes style__slide-bottom-center--Telj_ {
  from {
    opacity: 0;
    transform: translateY(calc(100vh));
  }
  to {
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./../components/src/Toast/style.less","webpack://./../components/src/shadows.less"],"names":[],"mappings":"AAMA;EAEI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,oBAAA;AANJ;AADA;EAWI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,oBAAA;AAPJ;AAPA;EAkBI,sBAAA;EACA,qBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,SAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;ECVF,yGAAA;ADGF;AApBA;EA+BM,eAAA;AARN;AAvBA;EAmCM,cAAA;EACA,gBAAA;AATN;AA3BA;EAwCM,8BAAA;EACA,cAAA;AAVN;AAaI;EACE,qBAAA;AAXN;AAcI;EACE,cAAA;AAZN;AAeI;EACE,cAAA;AAbN;AAgBI;EACE,8BAAA;EACA,SAAA;AAdN;AAiBI;EACE,8BAAA;EACA,SAAA;AAfN;AAkBI;EACE,aAAA;AAhBN;AAmBI;EACE,2DAAA;AAjBN;AAoBI;EACE,SAAA;EACA,yDAAA;AAlBN;AAqBI;EACE,2DAAA;AAnBN;AAsBI;EACE,4DAAA;AApBN;AAuBI;EACE,gEAAA;AArBN;AAwBI;EACE,+DAAA;AAtBN;AAyBI;EACE,kEAAA;AAvBN;AA0BI;EACE,mEAAA;AAxBN;AA2BI;EACE,iEAAA;AAzBN;AA4BI;EACE,oEAAA;AA1BN;AAlFA;EAiHI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AA5BJ;AAzFA;EAyHI,yBAAA;EACA,mBAAA;AA7BJ;AA7FA;EA8HI,yBAAA;EACA,mBAAA;AA9BJ;AAiCE;EACE;IACE,UAAA;IACA,6BAAA;IACA,kCAAA;EA/BJ;EAiCE;IACE,UAAA;IACA,2BAAA;IACA,6BAAA;EA/BJ;AACF;AAkCE;EACE;IACE,UAAA;IACA,4BAAA;EAhCJ;EAkCE;IACE,UAAA;IACA,wBAAA;EAhCJ;AACF;AAmCE;EACE;IACE,UAAA;IACA,WAAA;EAjCJ;EAmCE;IACE,UAAA;IACA,yBAAA;EAjCJ;AACF;AAoCE;EACE;IACE,UAAA;IACA,WAAA;EAlCJ;EAoCE;IACE,UAAA;IACA,UAAA;EAlCJ;AACF;AAqCE;EACE;IACE,UAAA;IACA,WAAA;EAnCJ;EAqCE;IACE,UAAA;IACA,WAAA;EAnCJ;AACF;AAsCE;EACE;IACE,UAAA;IACA,WAAA;EApCJ;EAsCE;IACE,UAAA;IACA,UAAA;EApCJ;AACF;AAuCE;EACE;IACE,SAAA;IACA,YAAA;IACA,UAAA;IACA,WAAA;EArCJ;EAuCE;IACE,SAAA;IACA,YAAA;IACA,UAAA;IACA,4BAAA;EArCJ;AACF;AAwCE;EACE;IACE,UAAA;IACA,YAAA;EAtCJ;EAwCE;IACE,UAAA;IACA,6BAAA;EAtCJ;AACF;AAyCE;EACE;IACE,UAAA;IACA,4BAAA;IACA,6BAAA;EAvCJ;EAyCE;IACE,UAAA;IACA,wBAAA;IACA,6BAAA;EAvCJ;AACF;AA0CE;EACE;IACE,UAAA;IACA,kCAAA;EAxCJ;EA0CE;IACE,UAAA;EAxCJ;AACF","sourcesContent":["@import '../colors';\n@import '../shadows';\n@import '../spacing';\n\n@notificationWidth: 358px;\n\n:local {\n  .toastContainer {\n    display: flex;\n    flex-direction: column;\n    gap: @spacing-100;\n    position: fixed;\n    z-index: 1400;\n    pointer-events: none;\n  }\n\n  .toastWrapper {\n    display: flex;\n    flex-direction: column;\n    gap: @spacing-100;\n    pointer-events: none;\n  }\n\n  .toast {\n    background-color: @color-white;\n    border-radius: @spacing-50;\n    color: @color-asphalt-grey-005;\n    padding: @spacing-100;\n    align-items: center;\n    display: flex;\n    gap: @spacing-100;\n    max-width: @notificationWidth;\n    justify-content: center;\n    pointer-events: auto;\n    .sys-elevation-shadow-level3();\n\n    > span {\n      cursor: pointer;\n    }\n\n    button {\n      color: @color-asphalt-grey-005;\n      border-radius: 0;\n    }\n\n    hr {\n      border-left: 1px solid @color-pewter-grey-090;\n      height: @spacing-150;\n    }\n\n    &Type {\n      justify-content: left;\n    }\n\n    &TypeError span {\n      color: @color-red-050;\n    }\n\n    &TypeSuccess span {\n      color: @color-green-060;\n    }\n\n    &Dismissible {\n      justify-content: space-between;\n      gap: @spacing-100;\n    }\n\n    &Action {\n      justify-content: space-between;\n      gap: @spacing-100;\n    }\n\n    &ActionButton {\n      display: flex;\n    }\n\n    &Top {\n      animation: 300ms ease-out forwards slide-down;\n    }\n\n    &Bottom {\n      top: 3rem;\n      animation: 300ms ease-out forwards slide-up;\n    }\n\n    &Left {\n      animation: 300ms ease-out forwards slide-left;\n    }\n\n    &Right {\n      animation: 300ms ease-out forwards slide-right;\n    }\n\n    &RightEnd {\n      animation: 300ms ease-out forwards slide-right-end;\n    }\n\n    &LeftEnd {\n      animation: 300ms ease-out forwards slide-left-end;\n    }\n\n    &LeftCenter {\n      animation: 300ms ease-out forwards slide-left-center;\n    }\n\n    &RightCenter {\n      animation: 300ms ease-out forwards slide-right-center;\n    }\n\n    &TopCenter {\n      animation: 300ms ease-out forwards slide-top-center;\n    }\n\n    &BottomCenter {\n      animation: 300ms ease-out forwards slide-bottom-center;\n    }\n  }\n\n  .iconContainer {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: @spacing-200;\n    height: @spacing-200;\n  }\n\n  .errorIcon {\n    background-color: @color-red-090;\n    border-radius: @spacing-200;\n  }\n\n  .successIcon {\n    background-color: @color-green-099;\n    border-radius: @spacing-200;\n  }\n\n  @keyframes slide-up {\n    from {\n      opacity: 0;\n      right: calc(50vw - @notificationWidth / 2);\n      transform: translateY(calc(100vh));\n    }\n    to {\n      opacity: 1;\n      transform: translateY(100vh - 19rem);\n      right: calc(50vw - @notificationWidth / 2);\n    }\n  }\n\n  @keyframes slide-down {\n    from {\n      opacity: 0;\n      transform: translateY(-@spacing-300);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n\n  @keyframes slide-left {\n    from {\n      opacity: 0;\n      left: 100vw;\n    }\n    to {\n      opacity: 1;\n      left: calc(100vw - 25rem);\n    }\n  }\n\n  @keyframes slide-right {\n    from {\n      opacity: 0;\n      left: -100%;\n    }\n    to {\n      opacity: 1;\n      left: @spacing-100;\n    }\n  }\n\n  @keyframes slide-right-end {\n    from {\n      opacity: 0;\n      right: 100%;\n    }\n    to {\n      opacity: 1;\n      right: @spacing-100;\n    }\n  }\n\n  @keyframes slide-left-end {\n    from {\n      opacity: 0;\n      left: 100vw;\n    }\n    to {\n      opacity: 1;\n      left: @spacing-100;\n    }\n  }\n\n  @keyframes slide-left-center {\n    from {\n      top: @spacing-100;\n      bottom: @spacing-100;\n      opacity: 0;\n      left: 100vw;\n    }\n    to {\n      top: @spacing-100;\n      bottom: @spacing-100;\n      opacity: 1;\n      left: calc(50vw - @notificationWidth / 2);\n    }\n  }\n\n  @keyframes slide-right-center {\n    from {\n      opacity: 0;\n      right: 100vw;\n    }\n    to {\n      opacity: 1;\n      right: calc(50vw - @notificationWidth / 2);\n    }\n  }\n\n  @keyframes slide-top-center {\n    from {\n      opacity: 0;\n      transform: translateY(-@spacing-300);\n      right: calc(50vw - @notificationWidth / 2);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n      right: calc(50vw - @notificationWidth / 2);\n    }\n  }\n\n  @keyframes slide-bottom-center {\n    from {\n      opacity: 0;\n      transform: translateY(calc(100vh));\n    }\n    to {\n      opacity: 1;\n    }\n  }\n}\n","@import 'colors';\n@import 'spacing';\n\n.sys-elevation-shadow-level0() {\n  box-shadow: 0 0 0 0 @color-asphalt-grey-005;\n}\n\n.sys-elevation-shadow-level1() {\n  box-shadow: 0 1px 3px 0 fade(@color-asphalt-grey-005, 10%),\n    0 1px @spacing-15 0 fade(@color-asphalt-grey-005, 6%);\n}\n\n.sys-elevation-shadow-level2() {\n  box-shadow: 0 @spacing-25 @spacing-50 -@spacing-15 fade(@color-asphalt-grey-005, 10%),\n    0 0 @spacing-25 -@spacing-15 fade(@color-asphalt-grey-005, 6%);\n}\n\n.sys-elevation-shadow-level2() {\n  box-shadow: 0 4px 8px -2px fade(@color-asphalt-grey-005, 10%),\n    0px 0px 4px -2px fade(@color-asphalt-grey-005, 6%);\n}\n\n.sys-elevation-shadow-level3() {\n  box-shadow: 0 @spacing-75 @spacing-100 -@spacing-25 fade(@color-asphalt-grey-005, 10%),\n    0 @spacing-25 6px -@spacing-15 fade(@color-asphalt-grey-005, 5%);\n}\n\n.sys-elevation-shadow-level4() {\n  box-shadow: 0 20px @spacing-150 -@spacing-25 fade(@color-asphalt-grey-005, 10%),\n    0 @spacing-50 @spacing-50 -@spacing-25 fade(@color-asphalt-grey-005, 4%);\n}\n\n.sys-elevation-shadow-level5() {\n  box-shadow: 0 @spacing-150 @spacing-300 -@spacing-75 fade(@color-asphalt-grey-005, 15%);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toastContainer": `style__toastContainer--Sr5Yq`,
	"toastWrapper": `style__toastWrapper--DA4Xm`,
	"toast": `style__toast--pvexy`,
	"toastType": `style__toastType--BiLlI`,
	"toastTypeError": `style__toastTypeError--Dh3vL`,
	"toastTypeSuccess": `style__toastTypeSuccess--TO1S0`,
	"toastDismissible": `style__toastDismissible--zNeh_`,
	"toastAction": `style__toastAction--syQF_`,
	"toastActionButton": `style__toastActionButton--Iq02Y`,
	"toastTop": `style__toastTop--vuyF2`,
	"slide-down": `style__slide-down--rmAbl`,
	"toastBottom": `style__toastBottom--Ap2J3`,
	"slide-up": `style__slide-up--d65DB`,
	"toastLeft": `style__toastLeft--t5WlM`,
	"slide-left": `style__slide-left--X6PgO`,
	"toastRight": `style__toastRight--PVGfj`,
	"slide-right": `style__slide-right--knifu`,
	"toastRightEnd": `style__toastRightEnd--Ukgdk`,
	"slide-right-end": `style__slide-right-end--HQeti`,
	"toastLeftEnd": `style__toastLeftEnd--fraOF`,
	"slide-left-end": `style__slide-left-end--PKEmk`,
	"toastLeftCenter": `style__toastLeftCenter--ma5bf`,
	"slide-left-center": `style__slide-left-center--ar_qE`,
	"toastRightCenter": `style__toastRightCenter--Ap9sh`,
	"slide-right-center": `style__slide-right-center--Kuf2p`,
	"toastTopCenter": `style__toastTopCenter--N9Oi5`,
	"slide-top-center": `style__slide-top-center--vOGcC`,
	"toastBottomCenter": `style__toastBottomCenter--v22if`,
	"slide-bottom-center": `style__slide-bottom-center--Telj_`,
	"iconContainer": `style__iconContainer--Nh_gQ`,
	"errorIcon": `style__errorIcon--jcUgu`,
	"successIcon": `style__successIcon--uk_ST`
};
export default ___CSS_LOADER_EXPORT___;
